import vm from '@/main'

const i18n = param => vm.$t(`_staff.labelProject.${param}`)
export default (form = {}) => {
  const column = [
    {
      label: i18n('projectId'),
      field: 'projectId',
      dictField: 'projectName',
      formOption: {
        rules: 'required',
        type: 'select',
        dictCode: 'project',
      },
    },
    {
      label: i18n('dept'),
      field: 'projectDept',
      dictField: 'projectDeptName',
      formOption: {
        rules: 'required',
        type: 'select',
        dictCode: 'dept',
        dictQuery: {
          deptCategory: 3,
        },
        hide: !form.projectId,
        small: vm.$t('_components.placeholder.firstInput') + i18n('projectId'),
      },
    },
    {
      label: i18n('post'),
      field: 'projectPost',
      dictField: 'projectPostName',
      formOption: {
        type: 'select',
        dictCode: 'post',
        dictQuery: {
          category: 3,
          deptId: form.projectDept,
        },
        hide: !form.projectDept,
        small: vm.$t('_components.placeholder.firstInput') + i18n('dept'),
      },
    },
    {
      label: i18n('jobTitle'),
      field: 'jobTitle',
      dictField: 'jobTitleName',
      formOption: {
        type: 'select',
        dictBizCode: 'job_title',
      },
    },
    {
      label: i18n('status'),
      field: 'status',
      dictField: 'statusName',
      formOption: {
        type: 'select',
        dictBizCode: 'project_status',
      },
    },
    {
      label: i18n('startDate'),
      field: 'startDate',
      type: 'date',
      dateInputFormat: 'yyyy-MM-dd',
      dateOutputFormat: 'MMM do yy',
      formOption: {
        type: 'date',
      },
    },
    {
      label: i18n('endDate'),
      field: 'endDate',
      type: 'date',
      dateInputFormat: 'yyyy-MM-dd',
      dateOutputFormat: 'MMM do yy',
      formOption: {
        hide: form.status !== '0',
        type: 'date',
      },
    },
    {
      label: i18n('expectEndDate'),
      field: 'expectEndDate',
      type: 'date',
      dateInputFormat: 'yyyy-MM-dd',
      dateOutputFormat: 'MMM do yy',
      formOption: {
        type: 'date',
      },
    },
    {
      label: i18n('projectPosition'),
      field: 'projectPosition',
    },
    {
      label: i18n('expensePercentage'),
      field: 'expensePercentage',
    },
    {
      label: i18n('sort'),
      field: 'sort',
      formOption: {
        type: 'number',
      },
    },
    {
      label: i18n('remark'),
      field: 'remark',
      formOption: {
        type: 'textarea',
      },
    },
  ]
  return column
}
